import Vue from 'vue';
import { getBirthMemberList, getExpireRemindMemberList} from "../../../services/personnelService/saService";

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  birthdayList: [],
  birthdaySelectedList: [],
  expireRemindList: [],
  expireRemindSelectedList: []
};
const actions = {
  // 取得生日會員名單
  async getBirthMemberListHandler({ commit }, paginationInfo) {
    const data = await getBirthMemberList(paginationInfo);
    commit('setBirthMemberList', data);
  },
  // 取得會籍到期提醒名單
  async getExpireRemindMemberListHandler({ commit }, paginationInfo) {
    const data = await getExpireRemindMemberList(paginationInfo);
    commit('setExpireRemindMemberList', data);
  }
};

// getters
const getters = {};

// mutations
const mutations = {
  setBirthMemberList(state, data) {
    Vue.set(state, 'birthdayList', data.data.members);
  },
  setBirthMemberSelectedList(state, member) {
    Vue.set(state, 'birthdaySelectedList', member);
  },
  setExpireRemindMemberList(state, data) {
    Vue.set(state, 'expireRemindList', data.data.members);
  },
  setExpireRemindMemberSelectedList(state, member) {
    Vue.set(state, 'expireRemindSelectedList', member);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
